import { Component, OnInit, TemplateRef, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { BsDatepickerViewMode, BsDatepickerConfig } from 'ngx-bootstrap/datepicker/ngx-bootstrap-datepicker';
import { SWAlertService } from '../../services/swalert.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscriber } from 'rxjs';
import { DatePipe } from '@angular/common';
import { EventEmitter } from 'events';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-supportdoc',
  templateUrl: './admin-supportdoc.component.html',
  styleUrls: ['./admin-supportdoc.component.css']
})
export class AdminSupportdocComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private System: TSFuntionService, private router: Router, private SW: SWAlertService, private modalService: BsModalService, public datepipe: DatePipe) { }
  SupportdocForm: FormGroup;
  iswait: boolean = true;
  arrCbExport: Array<any> = [];
  arrCbSupDoc: Array<any> = [];
  arrCbPaid: Array<any> = [];
  arrGL: any;
  arrMulti: any;
  lstData: any;
  isSupDoc: any;
  sSeeNote: any;
  sSearch: string = "";
  sDetailData = "";
  _ArrData = [];
  _ArrDataBind = [];
  //IsCheckbox: boolean = false;
  //IsSupDoc: boolean = false;
  ResultPermission: boolean = true;
  isResult: boolean = false;

  public settings = {};
  get _SupportdocForm() { return this.SupportdocForm.controls; }
  get SupDoc() { return this._SupportdocForm.SupDoc as FormArray; }
  FilterGrid = {
    sSearch: "",
    nStatusID: [],
    nReqTypeID: [],
    sCompanyCode: []
  }
  settings_com = {};
  ArrCompany = [];
  async ngOnInit() {

    this.SetForm();
    this.SupDoc.push(new FormGroup({
      cbExport: new FormControl(''),
      nYear: new FormControl(''),
      sPaymentDoc: new FormControl(''),
      sSupportDoc: new FormControl('', Validators.required),
      sReqNo: new FormControl(''),
      sReqType: new FormControl(''),
      sVendor: new FormControl(''),
      sCCTR: new FormControl(''),
      nTotalAmount: new FormControl(''),
      dDueDate: new FormControl(''),
      sNote: new FormControl(''),
      IsStatus: new FormControl(''),
      IsReqUrgent: new FormControl(''),
      IsVendorGroup: new FormControl(''),
      cbSubDoc: new FormControl(''),
      IsShow: new FormControl('')
    }))
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.ResultPermission = await this.System.CheckPermissionMeun(43); //F = ดู, T = แก้ 
    if (this.ResultPermission == false) {
      this.isResult = true;
    }
    else {
      this.isResult = false;
    }
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }

    await this.loadStatus();
    this.Search();
  }

  _Status = [];
  _RequestType = [];

  async loadStatus() {
    //Type
    let GetTaskType = await this.http.get<any>(this.System.SiteName + "api/AdminSupportdoc/GetTaskType").toPromise();
    if (GetTaskType) {
      this._RequestType = GetTaskType;
    }
    //Status
    let GetStatus = await this.http.get<any>(this.System.SiteName + "api/AdminSupportdoc/GetStatus").toPromise();
    if (GetStatus) {
      this._Status = GetStatus;
    }
    let GetCompany = await this.http.get<any>(this.System.SiteName + "api/AdminSupportdoc/GetCompany").toPromise();
    if (GetCompany) {
      this.ArrCompany = GetCompany;
    }
  }

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }

  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";


  @Output() onChange = new EventEmitter();
  Columns = [
    //{ ColumnName: "Req. No.", SortField: "sRequestCode", Width: "10%" },
    //{ ColumnName: "Type", SortField: "sReqType", Width: "13%" },
    //{ ColumnName: "Vendor", SortField: "vendor", Width: "18%" },
    //{ ColumnName: "", SortField: "", Width: "3%" },
    //{ ColumnName: "Cost Center", SortField: "sCCTR", Width: "10%" },
    //{ ColumnName: "Net Total", SortField: "nGrandTotalAmtInvoice", Width: "13%" },
    //{ ColumnName: "Due Date", SortField: "dDueDate_SSC", Width: "8%" },
    //{ ColumnName: "Note", SortField: "sDocHeader", Width: "7%" }

    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "8%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "13%" },
    { ColumnName: "Vendor / Customer", SortField: "vendor", Width: "17%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Cost Center", SortField: "sCCTR", Width: "9%" },
    { ColumnName: "Net Total", SortField: "nGrandTotalAmtInvoice", Width: "12%" },
    { ColumnName: "Due Date", SortField: "dDueDate_SSC", Width: "7%" },
    { ColumnName: "Note", SortField: "sDocHeader", Width: "8%" }
  ]


  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }


  BindDataTable() {
    let _this = this;
    this.OptionGrid.nTotalItem = this._ArrData.length;
    let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    let nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];

    if (this.arrCbSupDoc.length > 0 || this.arrCbExport.length > 0) {
      this._ArrData.forEach(function (item) {
        let itemCheckedSupDoc = _this.arrCbSupDoc.filter(m => m.sRequestID == item.sRequestCode);
        let itemCheckedExport = _this.arrCbExport.filter(m => m.sRequestID == item.sRequestCode);
        _this._ArrDataBind.push(Object.assign({
          cbExport: itemCheckedExport.length > 0 ? itemCheckedExport[0].isChecked : false,
          cbSubDoc: itemCheckedSupDoc.length > 0 ? itemCheckedSupDoc[0].isChecked : item.sSupportingDocument != null ? true : false
        }, item));
      });
    }
    else {
      if (this.isResult == false) {
        var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
        cbExport_All.checked = false;
      }
      this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ cbSubDoc: val.sSupportingDocument != null && val.nStatusID == 12 ? true : false }, val)));
    }

    //this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();

    this.SupDoc.clear();
    this._SupportdocForm.SupDoc.reset();
    let num = 0;
    this._ArrDataBind.forEach(function (datain, i) {
        _this.SupDoc.push(new FormGroup({
          cbExport: new FormControl(''),
          nYear: new FormControl(''),
          sPaymentDoc: new FormControl(''),
          sSupportDoc: new FormControl('', Validators.required),
          sReqNo: new FormControl(''),
          sReqType: new FormControl(''),
          sVendor: new FormControl(''),
          sCCTR: new FormControl(''),
          nTotalAmount: new FormControl(''),
          dDueDate: new FormControl(''),
          sNote: new FormControl(''),
          IsStatus: new FormControl(''),
          IsReqUrgent: new FormControl(''),
          IsVendorGroup: new FormControl(''),
          cbSubDoc: new FormControl(''),
          IsShow: new FormControl('')
        }))
        _this.SupDoc.at(num).patchValue({
          cbExport: datain.cbExport,
          cbSubDoc: datain.cbSubDoc,
          nYear: datain.nYear,
          sPaymentDoc: datain.sPaymentDoc,
          sSupportDoc: datain.sSupportingDocument,
          sReqNo: datain.sRequestCode,
          sReqType: datain.sReqType,
          IsReqType: datain.nReqTypeID,
          sVendor: datain.vendor,
          sCCTR: datain.sCCTR,
          nTotalAmount: datain.nGrandTotalAmtInvoice,//datain.nGrandTotalAmt,
          dDueDate: datain.dDueDate_SSC,//datain.dDueDate,
          sNote: datain.sDocHeader,
          IsStatus: datain.nStatusID,
          IsReqUrgent: datain.IsReqUrgent,
          IsVendorGroup: datain.IsVendorGroup,
          IsShow: datain.sSupportingDocument == null ? true : false,
          //IsNoteM: datain.sDocHeader.length > 5 ? true : false,
        })
        num++;
      })
      let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (value, i) {
        if (value.get("IsStatus").value == 12) {
          if (value.value.cbSubDoc == false) {
            value.get("sSupportDoc").disable();
          }
        } else {
          value.get("sSupportDoc").disable();
        }
        let nCheckItemExport = _this.SupDoc.value.filter(w => w.cbExport == true).length;
        var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
        cbExport_All.checked = FromArray.value.length == nCheckItemExport;

        let nCheckItemSubDoc = _this.SupDoc.value.filter(w => w.cbSubDoc == true).length;
        var cbSupDoc_All = <HTMLInputElement>document.getElementById("cbSupDoc_All");
        cbSupDoc_All.checked = FromArray.value.length == nCheckItemSubDoc;
      })
      FromArray.controls.forEach(function (forms, i) {
        if (forms.get("IsStatus").value == 9) {
          if (forms.value.cbSubDoc == false) {
            forms.get("sPaymentDoc").disable();
            forms.get("sSupportDoc").disable();
            forms.get("nYear").disable();
            forms.get("cbSubDoc").disable();
          }
        } else {
          _this.iswait = false;
        }
      })
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  CbSaveAll(item, sReq) {
    if (item.target.checked == false) {
      let row = this.arrCbExport.filter(m => m.sRequestID == sReq);
      if (row.length > 0) {
        row[0].isChecked = false;
      }

    } else {
      let obj = {
        sRequestID: sReq,
        isChecked: item.target.checked,
      };
      let row = this.arrCbExport.filter(m => m.sRequestID == sReq);
      if (row.length > 0) {
        row[0].isChecked = true;
      }
      else {
        this.arrCbExport.push(obj);
      }
    }
  }

  DExport(item, sReqNo) {
    if (item.target.checked == true) {
      let row = this.arrCbExport.filter(m => m.sRequestID == sReqNo);
      if (row.length > 0) {
        row[0].isChecked = false;
      }
    }
  }

  CbSupDocSaveAll(item, sReqNo) {
    if (item.target.checked == false) {
      //ตัดออก
      //let row = this.arrCbExport.map(function (e) { return e.sReq; }).indexOf(sReq);
      //this.arrCbExport.splice(row, 1);
      //อัพเดต
      let row = this.arrCbSupDoc.filter(m => m.sRequestID == sReqNo);
      if (row.length > 0) {
        row[0].isChecked = false;
      }

    } else {
      let obj = {
        sRequestID: sReqNo,
        isChecked: item.target.checked,
      };
      let row = this.arrCbSupDoc.filter(m => m.sRequestID == sReqNo);
      if (row.length > 0) {
        row[0].isChecked = true;
      }
      else {
        this.arrCbSupDoc.push(obj);
      }
    }
  }

  DSupDoc(item, sReqNo) {
    if (item.target.checked == true) {
      let row = this.arrCbSupDoc.filter(m => m.sRequestID == sReqNo);
      if (row.length > 0) {
        row[0].isChecked = false;
      }
    }
  }

  cbExport(item, sReq) {
    let _this = this;
    let row = _this.SupDoc.value.map(function (e) { return e.sReqNo; }).indexOf(sReq);
    let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
    if (_this.SupDoc.at(row).value.IsStatus == 12) {

      if (item.target.checked == false) { //ปิด
        _this.SupDoc.at(row).patchValue({ cbExport: false })
        _this.CbSaveAll(item, sReq);
        _this.CbSupDocSaveAll(item, _this.SupDoc.at(row).value.sReqNo);

      } else { //เปิด
        _this.SupDoc.at(row).patchValue({ cbExport: true })
        _this.CbSaveAll(item, sReq);

        _this.SupDoc.at(row).patchValue({ cbSupDoc_All: false })
        if (_this.SupDoc.at(row).value.IsStatus == 12 && _this.SupDoc.at(row).value.IsShow == false) {
          _this.SupDoc.at(row).get('sSupportDoc').setValidators(Validators.required);
          _this.SupDoc.at(row).get('sSupportDoc').updateValueAndValidity();
          _this.SupDoc.at(row).get('sSupportDoc').enable()
        }
        else {
          _this.SupDoc.at(row).patchValue({ cbSubDoc: false })
          _this.DSupDoc(item, _this.SupDoc.at(row).value.sReqNo);

          _this.SupDoc.at(row).get('sSupportDoc').disable()
          _this.SupDoc.at(row).get('sSupportDoc').clearValidators();
          _this.SupDoc.at(row).get('sSupportDoc').markAsUntouched({ onlySelf: true });
          _this.SupDoc.at(row).get('sSupportDoc').setErrors(null);
          //_this.SupDoc.at(row).get('sSupportDoc').setValidators([]);
          _this.SupDoc.at(row).get('sSupportDoc').patchValue("");
          _this.SupDoc.at(row).get('sSupportDoc').updateValueAndValidity();
        }
        //this.IsSupDoc = false;
      }

      //ExportAll
      //FromArray.at(row).get("cbExport").patchValue({ cbExport: item.target.checked });
      let nCheckItem = _this.SupDoc.value.filter(w => w.cbExport == true).length;
      var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
      cbExport_All.checked = FromArray.value.length == nCheckItem;

      //SubDocAll
      var cbSupDoc_All = <HTMLInputElement>document.getElementById("cbSupDoc_All");
      cbSupDoc_All.checked = false;
    }
  }

  cbExportAll(item) {
    let _this = this;
    if (item.target.checked == true) {
      let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (arr, i) {
        arr.patchValue({ cbExport: true })

        if (arr.value.IsStatus == 12 && arr.value.IsShow == false) { //&& arr.value.sSupportDoc != ""
          arr.patchValue({ cbSupDoc_All: false })
          arr.patchValue({ cbSubDoc: false })
          arr.get('sSupportDoc').setValidators(Validators.required);
          arr.get('sSupportDoc').updateValueAndValidity();
          arr.get('sSupportDoc').enable();
          //arr.get('sSupportDoc').patchValue("");
        }
        else {
          arr.patchValue({ cbSupDoc_All: false })
          arr.patchValue({ cbSubDoc: false })
          _this.DSupDoc(item, arr.value.sReqNo);
          arr.get('sSupportDoc').disable()
          arr.get('sSupportDoc').clearValidators();
          arr.get('sSupportDoc').markAsUntouched({ onlySelf: true });
          arr.get('sSupportDoc').setErrors(null);
          //arr.get('sSupportDoc').setValidators([]);
          //arr.get('sSupportDoc').patchValue("");
          arr.get('sSupportDoc').updateValueAndValidity();
        }
        _this.CbSaveAll(item, arr.value.sReqNo);
      })
    } else if (item.target.checked == false) {
      let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (arr, i) {
        arr.patchValue({ cbExport: false })

        if (arr.value.IsStatus == 12 && arr.value.IsShow == false) {
          arr.patchValue({ cbSupDoc_All: false })
          arr.get('sSupportDoc').setValidators(Validators.required);
          arr.get('sSupportDoc').updateValueAndValidity();
          arr.get('sSupportDoc').enable();
        }
        else {
          arr.patchValue({ cbSupDoc_All: false })
          arr.patchValue({ cbSubDoc: false })
          _this.CbSupDocSaveAll(item, arr.value.sReqNo);
          arr.get('sSupportDoc').disable()
          arr.get('sSupportDoc').clearValidators();
          arr.get('sSupportDoc').markAsUntouched({ onlySelf: true });
          arr.get('sSupportDoc').setErrors(null);
          //arr.get('sSupportDoc').setValidators([]);
          //arr.get('sSupportDoc').patchValue("");
          arr.get('sSupportDoc').updateValueAndValidity();
          //this.IsSupDoc = true;
        }
        _this.CbSaveAll(item, arr.value.sReqNo);
      })
    }
    //SubDocAll
    var cbSupDoc_All = <HTMLInputElement>document.getElementById("cbSupDoc_All");
    cbSupDoc_All.checked = false;
  }

  cbSupDocAll(item) {
    let _this = this;
    if (item.target.checked == true) {
      let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (arr, i) {
        //if (FromArray.value.IsStatus == "12") {
        if (arr.value.IsStatus == 12) {
          arr.patchValue({ cbSubDoc: true })
          arr.get('sSupportDoc').setValidators(Validators.required);
          arr.get('sSupportDoc').updateValueAndValidity();
          arr.get('sSupportDoc').enable()

          //this.IsCheckbox = false;
          arr.patchValue({ cbExport: false })
          arr.patchValue({ cbExport_All: false })
          //_this.CbSupDocSaveAll(item, arr.value.sReqNo);
          _this.DExport(item, arr.value.sReqNo);
        }
        else {
          arr.patchValue({ cbSubDoc: false })
          arr.get('sSupportDoc').disable()
          arr.get('sSupportDoc').clearValidators();
          arr.get('sSupportDoc').markAsUntouched({ onlySelf: true });
          arr.get('sSupportDoc').setErrors(null);
          //arr.get('sSupportDoc').setValidators([]);
          arr.get('sSupportDoc').updateValueAndValidity();
          //arr.get('sSupportDoc').patchValue("");
          //this.IsCheckbox = true;
          arr.patchValue({ cbExport: false })
          arr.patchValue({ cbExport_All: false })
          _this.DExport(item, arr.value.sReqNo);
        }
        _this.CbSupDocSaveAll(item, arr.value.sReqNo);
      })
    } else if (item.target.checked == false) {
      let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
      FromArray.controls.forEach(function (arr, i) {

        if (arr.value.IsStatus == 12 && arr.value.IsShow == false) {
          //arr.patchValue({ cbSupDoc_All: false })
          arr.patchValue({ cbSubDoc: true })
          arr.get('sSupportDoc').setValidators(Validators.required);
          arr.get('sSupportDoc').updateValueAndValidity();
          arr.get('sSupportDoc').enable();
        }
        else {
          arr.patchValue({ cbSubDoc: false })

          arr.patchValue({ cbExport: false })
          arr.patchValue({ cbExport_All: false })
          _this.CbSaveAll(item, arr.value.sReqNo);

          arr.get('sSupportDoc').disable()
          arr.get('sSupportDoc').clearValidators();
          arr.get('sSupportDoc').markAsUntouched({ onlySelf: true });
          arr.get('sSupportDoc').setErrors(null);
          //arr.get('sSupportDoc').setValidators([]);
          arr.get('sSupportDoc').updateValueAndValidity();
          //arr.get('sSupportDoc').patchValue("");
          //this.IsCheckbox = true;          
        }
        _this.CbSupDocSaveAll(item, arr.value.sReqNo);
      })
    }
    //ExportAll
    var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
    cbExport_All.checked = false;
  }

  cbSubDoc(item, index) {
    let _this = this;
    let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
    const control = FromArray.at(index).get('sSupportDoc');
    control.disabled == false ? control.disable() : control.enable();
    if (control.disabled == true) {
      control.clearValidators();
      control.markAsUntouched({ onlySelf: true });
      control.setErrors(null);
      control.setValidators([]);
      control.patchValue("");
      control.updateValueAndValidity();
      if (_this.SupDoc.at(index).value.IsStatus != 12) {
        control.patchValue("");
      }
      //_this.CbSupDocSaveAll(item, index);
    } else {
      //control.patchValue({ cbSubDoc: true })
      control.setValidators(Validators.required);
      control.updateValueAndValidity();
      control.patchValue("");
      //control.setValidators([]);
      control.updateValueAndValidity();
      //_this.CbSupDocSaveAll(item, index);
    }
    if (item.target.checked == false) {
      _this.SupDoc.at(index).patchValue({ cbSubDoc: false })
      _this.SupDoc.at(index).patchValue({ cbExport: false })
      _this.SupDoc.at(index).patchValue({ cbExport_All: false })
      _this.CbSaveAll(item, _this.SupDoc.at(index).value.sReqNo);
      //this.IsCheckbox = false;
    } else {
      _this.SupDoc.at(index).patchValue({ cbSubDoc: true })
      _this.SupDoc.at(index).patchValue({ cbExport: false })
      _this.SupDoc.at(index).patchValue({ cbExport_All: false })
      _this.DExport(item, _this.SupDoc.at(index).value.sReqNo);
      //_this.CbSupDocSaveAll(item, index);      
      //this.IsCheckbox = true;
    }

    //SubDocAll
    FromArray.at(index).get("cbSubDoc").patchValue(item.target.checked);
    let nCheckItem = _this.SupDoc.value.filter(w => w.cbSubDoc == true).length;
    var cbSupDoc_All = <HTMLInputElement>document.getElementById("cbSupDoc_All");
    cbSupDoc_All.checked = FromArray.value.length == nCheckItem;

    //ExportAll
    var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
    cbExport_All.checked = false;

    _this.CbSupDocSaveAll(item, _this.SupDoc.at(index).value.sReqNo);
  }

  Export() {
    //let Expor = this.SupDoc.value.filter(f => f.cbExport == true);
    //let SubDoc = this.SupDoc.value.filter(f => f.cbSubDoc == true);
    let _this = this;
    //let SaveDataExpor = _this.SupDoc.value.filter(f => f.cbExport == true).map(m => ({ sRequestCode: m.sReqNo, IsExport: m.cbExport, sPaymentDoc: m.sPaymentDoc, nYear: m.nYear }))
    let SaveDataExpor = _this.SupDoc.value.filter(f => f.cbExport == true).map(m => ({ sRequestCode: m.sReqNo, IsExport: m.cbExport }))
    let SaveStatus = function () {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let Dataexport = JSON.stringify(SaveDataExpor)
      _this.http.post(_this.System.SiteName + "api/AdminSupportdoc/Save", Dataexport, { headers, responseType: 'text' }).subscribe(s => {
        if (s == "Success") {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
            _this.arrCbExport = [];
            _this.arrCbSupDoc = [];
            _this.Search();
          });
        }
      })
    }

    let SaveDataSubDoc = _this.SupDoc.value.filter(f => f.cbSubDoc == true).map(m => ({ sRequestCode: m.sReqNo, IsSubDoc: m.cbSubDoc, sSupportDoc: m.sSupportDoc, nYear: m.nYear }))
    let SaveStatusSUD = function () {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let DataSubDoc = JSON.stringify(SaveDataSubDoc)
      _this.http.post(_this.System.SiteName + "api/AdminSupportdoc/Paid", DataSubDoc, { headers, responseType: 'text' }).subscribe(s => {
        if (s == "Success") {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
            _this.arrCbExport = [];
            _this.arrCbSupDoc = [];
            _this.Search();
          });
        }
      })
    }

    let SaveStatusSUM = function () {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let Dataexport = JSON.stringify(SaveDataExpor)
      _this.http.post(_this.System.SiteName + "api/AdminSupportdoc/Save", Dataexport, { headers, responseType: 'text' }).subscribe(s => {
        if (s == "Success") {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
            _this.arrCbExport = [];
            _this.arrCbSupDoc = [];
            _this.Search();
          });
        }
      })
      let DataSubDoc = JSON.stringify(SaveDataSubDoc)
      _this.http.post(_this.System.SiteName + "api/AdminSupportdoc/Paid", DataSubDoc, { headers, responseType: 'text' }).subscribe(s => {
        if (s == "Success") {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, "Data is already saved.", function () {
            _this.arrCbExport = [];
            _this.arrCbSupDoc = [];
            _this.Search();
          });
        }
      })
    }

    let isvalid: boolean = true;
    for (var i = 0; i < this.SupDoc.length; i++) {
      if (!this.SupDoc.at(i).get('sSupportDoc').valid && this.SupDoc.at(i).get('sSupportDoc').disabled != true) {
        isvalid = false;
      }
    }

    if (SaveDataExpor.length > 0 && SaveDataSubDoc.length <= 0) {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, "Do you want to Save data?", SaveStatus, function () { });
    }
    else if (SaveDataSubDoc.length <= 0 && SaveDataExpor.length <= 0) {
      this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_Warning, "Please select the information you want to Save?", function () { });
    }
    else if (SaveDataSubDoc.length > 0 && SaveDataExpor.length <= 0) {
      if (isvalid && SaveDataSubDoc.length > 0) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, "Do you want to Save data?", SaveStatusSUD, function () { });
      } else {
        for (var i = 0; i < this.SupDoc.length; i++) {
          if (!this.SupDoc.at(i).get('sSupportDoc').valid && this.SupDoc.at(i).get('sSupportDoc').disabled != true) {
            _this.SupDoc.at(i).get('sSupportDoc').markAsTouched({ onlySelf: true })
          }
        }
      }
    }
    else {
      if (isvalid && SaveDataSubDoc.length > 0 && SaveDataExpor.length > 0) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, "Do you want to Save data?", SaveStatusSUM, function () { });
      } else {
        for (var i = 0; i < this.SupDoc.length; i++) {
          if (!this.SupDoc.at(i).get('sSupportDoc').valid && this.SupDoc.at(i).get('sSupportDoc').disabled != true) {
            _this.SupDoc.at(i).get('sSupportDoc').markAsTouched({ onlySelf: true })
          }
        }
      }
    }
    //if (SaveDataSubDoc.length <= 0 && SaveDataExpor.length <= 0) {
    //  this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_Warning, "Please select the information you want to Save?", function () { });
    //}
  }

  async Search() {
    this.OptionGrid.nCurrentPage = 1;
    this.SupDoc.clear();
    this._SupportdocForm.SupDoc.reset();
    let _this = this;
    let data: any;
    let ReqType: string = this.FilterGrid.nReqTypeID.length > 0 ? this.FilterGrid.nReqTypeID.map(e => e.sValue).join(",") : "";
    let Status: string = this.FilterGrid.nStatusID.length > 0 ? this.FilterGrid.nStatusID.map(e => e.sValue).join(",") : "";
    let sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.COMPANY_CODE).join(",") : "";
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('sStatus', Status)
        .set('sReqType', ReqType)
        .set('sCompanyCode', sCompanyCode)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdminSupportdoc/Search", httpOptions).toPromise().then(Data => {
      if (Data) {
        data = Data
        this._ArrData = Data,
          this._ArrDataBind = Data
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
    //this.lstData = data;
    //let arrData = [];

    //if (this.arrCbSupDoc.length > 0 || this.arrCbExport.length > 0) {
    //  this.lstData.forEach(function (item) {
    //    let itemCheckedSupDoc = _this.arrCbSupDoc.filter(m => m.sRequestID == item.sRequestCode);
    //    let itemCheckedExport = _this.arrCbExport.filter(m => m.sRequestID == item.sRequestCode);
    //    arrData.push(Object.assign({
    //      cbExport: itemCheckedExport.length > 0 ? itemCheckedExport[0].isChecked : false,
    //      cbSubDoc: itemCheckedSupDoc.length > 0 ? itemCheckedSupDoc[0].isChecked : item.sSupportingDocument != null ? true : false
    //    }, item));
    //  });

    //  let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;

    //  let nCheckItemExport = arrData.filter(w => w.cbExport == true).length;
    //  var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
    //  cbExport_All.checked = FromArray.value.length == nCheckItemExport;

    //  let nCheckItemSubDoc = arrData.filter(w => w.cbSubDoc == true).length;
    //  var cbSupDoc_All = <HTMLInputElement>document.getElementById("cbSupDoc_All");
    //  cbSupDoc_All.checked = FromArray.value.length == nCheckItemSubDoc;
    //}
    //else {
    // //arrData = this.lstData;
    //    this.lstData.forEach(function (item) {
    //      arrData.push(Object.assign({ cbSubDoc: item.sSupportingDocument != null ? true : false }, item));
    //    });
    //}

    //this.SupDoc.clear();
    //this._SupportdocForm.SupDoc.reset();
    //let num = 0;
    //if (arrData != null) {
    //  arrData.forEach(function (datain, i) {
    //    _this.SupDoc.push(new FormGroup({
    //      cbExport: new FormControl(''),
    //      nYear: new FormControl(''),
    //      sPaymentDoc: new FormControl(''),
    //      sSupportDoc: new FormControl('', Validators.required),
    //      sReqNo: new FormControl(''),
    //      sReqType: new FormControl(''),
    //      sVendor: new FormControl(''),
    //      sCCTR: new FormControl(''),
    //      nTotalAmount: new FormControl(''),
    //      dDueDate: new FormControl(''),
    //      sNote: new FormControl(''),
    //      IsStatus: new FormControl(''),
    //      IsReqUrgent: new FormControl(''),
    //      IsVendorGroup: new FormControl(''),
    //      cbSubDoc: new FormControl(''),
    //      IsShow: new FormControl('')
    //    }))
    //    _this.SupDoc.at(num).patchValue({
    //      cbExport: datain.cbExport,
    //      cbSubDoc: datain.cbSubDoc,/*datain.sSupportingDocument != null ? true : false, || datain.cbSubDoc*/
    //      nYear: datain.nYear,
    //      sPaymentDoc: datain.sPaymentDoc,
    //      sSupportDoc: datain.sSupportingDocument, 
    //      sReqNo: datain.sRequestCode,
    //      sReqType: datain.sReqType,
    //      IsReqType: datain.nReqTypeID,
    //      sVendor: datain.vendor,
    //      sCCTR: datain.sCCTR,
    //      nTotalAmount: datain.nGrandTotalAmt,
    //      dDueDate: datain.dDueDate,
    //      sNote: datain.sDocHeader,
    //      IsStatus: datain.nStatusID,
    //      IsReqUrgent: datain.IsReqUrgent,
    //      IsVendorGroup: datain.IsVendorGroup,
    //      IsShow: datain.sSupportingDocument == null ? true : false,
    //    })
    //    num++;
    //  })
    //  let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
    //  FromArray.controls.forEach(function (value, i) {
    //    if (value.get("IsStatus").value == 12) {
    //      if (value.value.cbSubDoc == false) {
    //        value.get("sSupportDoc").disable();
    //      }
    //    } else {
    //      value.get("sSupportDoc").disable();
    //    }     
    //  })

    //  //-------------------------------------
    //  FromArray.controls.forEach(function (forms, i) {
    //    if (forms.get("IsStatus").value == 9) {
    //      if (forms.value.cbSubDoc == false) {
    //        forms.get("sPaymentDoc").disable();
    //        forms.get("sSupportDoc").disable();
    //        forms.get("nYear").disable();
    //        forms.get("cbSubDoc").disable();
    //      }
    //    } else {
    //      _this.iswait = false;
    //    }
    //  })
    //}
  }

  async seeCCTR(template: TemplateRef<any>, sRequestCode) {
    let cctrData = { sRequestCode }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminSupportdoc/GetsCCTR", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  seeNote(Note: TemplateRef<any>, index) {
    this.sSeeNote = this.SupDoc.at(index).get('sNote').value;
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(Note, config);
  }

  async seeItem(Multi: TemplateRef<any>, sReqNo) {
    let ItemData = { sReqNo }
    let sendData = JSON.stringify(ItemData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let dataMulti: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminSupportdoc/_GetItems", sendData, { headers, responseType: 'text' }).toPromise().then(Data => dataMulti = Data)
      this.arrMulti = JSON.parse(dataMulti);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(Multi, config);
  }

  handler(row) {
    let _this = this;
    this.SupDoc.at(row).patchValue({
      nYear: +this.datepipe.transform(new Date(_this.SupDoc.at(row).value.nYear), 'yyyy')
    })
  }

  SetForm() {
    this.SupportdocForm = this.formBuilder.group({
      SupDoc: new FormArray([
        new FormGroup({
          cbExport: new FormControl(''),
          nYear: new FormControl(''),
          sPaymentDoc: new FormControl(''),
          sSupportDoc: new FormControl('', Validators.required),
          sReqNo: new FormControl(''),
          sReqType: new FormControl(''),
          sVendor: new FormControl(''),
          sCCTR: new FormControl(''),
          nTotalAmount: new FormControl(''),
          dDueDate: new FormControl(''),
          sNote: new FormControl(''),
          IsStatus: new FormControl(''),
          IsReqUrgent: new FormControl(''),
          IsVendorGroup: new FormControl(''),
          cbSubDoc: new FormControl(''),
          IsShow: new FormControl('')
        })
      ]),
    });

  }

  isFieldValidTbExprot(_Field: string, _inx) {
    let FromArray = this.SupportdocForm.get('SupDoc') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }

  displayFieldCssTbExprot(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbExprot(_Field, _inx),
      'has-feedback': this.isFieldValidTbExprot(_Field, _inx)
    };
  }

  onClick(value: string) {
    let _this = this;
    if (value == "Back") {
      this.router.navigate(["/admin-menu"]);
    }
  }

  onClear() {
    this.FilterGrid.nReqTypeID = [];
    this.FilterGrid.nStatusID = [];
    this.FilterGrid.sSearch = "";
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }
    this.Search();
  }
}
